export default __webpack_public_path__ + "static/media/tanrat.cdd066e1.png";